import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './authPopup.css';

const Signup = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    fullName: '',
    email: '',
    password: '',
    remember: false,
  });

  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
  };

  const handleSignup = (e) => {
    e.preventDefault();
    navigate('/Home');
  };

  return (
    <main className="authPage">
      <div className="authCard">
        <button className="authCloseBtn" onClick={() => navigate(-1)}>
          ×
        </button>

        <h1>Create account</h1>

        <form onSubmit={handleSignup}>
          <label>
            Full name
            <input
              type="text"
              value={form.fullName}
              onChange={(e) => handleChange('fullName', e.target.value)}
            />
          </label>

          <label>
            Email
            <input
              type="email"
              value={form.email}
              onChange={(e) => handleChange('email', e.target.value)}
            />
          </label>

          <label>
            Password
            <input
              type="password"
              value={form.password}
              onChange={(e) => handleChange('password', e.target.value)}
            />
          </label>

          <div className="authOptions">
            <label className="checkLabel">
              <input
                type="checkbox"
                checked={form.remember}
                onChange={(e) => handleChange('remember', e.target.checked)}
              />
              Remember me
            </label>

            <button type="button" className="textBtn">
              Forgot password?
            </button>
          </div>

          <button type="submit" className="authMainBtn">
            Get started
          </button>
        </form>

        <div className="socialDivider">
          <span></span>
          <p>Sign in with</p>
          <span></span>
        </div>

        <div className="socialBtns">
          <button></button>
          <button>G</button>
          <button>f</button>
        </div>

        <p className="authBottomText">
          Already have an account?{' '}
          <button onClick={() => navigate('/Login')}>Sign in</button>
        </p>
      </div>
    </main>
  );
};

export default Signup;